module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\"><path d=\"M9 8c1.66 0 2.99-1.34 2.99-3S10.66 2 9 2C7.34 2 6 3.34 6 5s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V16h14v-2.5c0-2.33-4.67-3.5-7-3.5z\" fill=\"#585858\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/footer-user.svg
// module id = 543
// module chunks = 1